// extracted by mini-css-extract-plugin
module.exports = {"app-input":"_input_app-input__1cBGl","description":"_input_description__3gfm3"};